import * as cx from 'classnames'
import * as React from 'react'

const SearchHeader = ({
  currentSite,
  children,
  styles = {}
}: {
  currentSite: string
  children: any
  styles: any
}) => {
  const pageSectionClassNames = cx(
    styles.pageSection,
    'page-section',
    '-size-xcompact',
    `-theme-${currentSite || 'themeforest'}`
  )

  return (
    <div id="search-header">
      <div className={pageSectionClassNames}>
        <div className={cx(styles.pageSectionContent, 'page-section__content')}>
          <div
            className={cx(
              styles.pageSectionBackground,
              'page-section__background'
            )}
          />
          <div
            className={cx(
              styles.pageSectionForm,
              'search-header__form-wrapper'
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchHeader



// WEBPACK FOOTER //
// ./client/components/searchHeader/searchHeader.tsx